import store from '@/store/index.js'
let dic = store.state.dic;
import { isNumSymbol } from "@/libs/checker.js";
import { validatePhone, validateCardIdCorrect, validateEmailCorrect } from "@/libs/elementChecker";
export default function Configs(that) {
    // 密码验证
    // 密码验证
    var validatePass = (rule, value, callback) => {
        if (value === "") {
            callback(new Error("请输入密码"));
        } else {
            if (!isNumSymbol(value)) {
                callback(new Error("请输入密码，8-20个字符，由数字和大小写字母及特殊字符组合"));
            } else {
                if (that.handleData.verifyPassword !== "") {
                    that.$refs.cForm.$refs.cForm.validateField("verifyPassword");
                }
                callback();
            }
        }
    };
    var validatePass2 = (rule, value, callback) => {
        if (value === "") {
            callback(new Error("请再次输入密码"));
        } else if (value !== that.handleData.password) {
            callback(new Error("两次输入密码不一致!"));
        } else {
            callback();
        }
    };

    var validatePassword = (rule, value, callback) => {
        if (value === "") {
            callback(new Error("请输入密码"));
        } else {
            if (!isNumSymbol(value)) {
                callback(new Error("请输入密码，8-20个字符，由数字和大小写字母及特殊字符组合"));
            } else {
                if (that.pwdData.verifyPassword !== "") {
                    that.$refs.pForm.$refs.cForm.validateField("verifyPassword");
                }
                callback();
            }
        }
    };
    var validateResetPassword = (rule, value, callback) => {
        if (value === "") {
            callback(new Error("请再次输入密码"));
        } else if (value !== that.pwdData.password) {
            callback(new Error("两次输入密码不一致!"));
        } else {
            callback();
        }
    };
    function validateOrgId(rule, value, callback) {
        if (that.handleData.orgId == '') {
            callback('请选择所属部门')
        } else {
            callback()
        }

    }
    const searchItems = [
        {
            label: "用户类别",
            span: 6,
            placeholder: '请选择',
            model: "category",
            type: 'select',
            options: dic._USER_CATEGORY
        },
        {
            label: "角色",
            span: 6,
            placeholder: '请选择角色',
            model: "rId",
            type: 'select',
            options: []
        },
        {
            label: "姓名",
            span: 6,
            placeholder: '请输入姓名',
            model: "name"
        },
        {
            label: "用户名",
            span: 6,
            placeholder: '请输入用户名',
            model: "username"
        },
        // {
        //     label: "电话",
        //     span: 8,
        //     placeholder: '请输入电话',
        //     model: "phoneNumber"
        // },
    ]


    const tableColumns = [
        {
            label: "姓名",
            prop: "name",
            align: "center",
            show: true
        },
        {
            label: "用户名",
            prop: "username",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "性别",
            prop: "sexName",
            align: "center",
            show: true
        },
        {
            label: "角色",
            prop: "roleName",
            align: "center",
            show: true
        },

        // {
        //     label: "所属单位",
        //     prop: "orgName",
        //     align: "center",
        //     show: true
        // },
        // {
        //     label: "电话",
        //     prop: "66",
        //     align: "center",
        //     show: true
        // },
        // {
        //     label: "邮箱",
        //     prop: "77",
        //     align: "center",
        //     show: true
        // },
        {
            label: "操作",
            name: "custom",
            align: "center",
            show: true,
            width: "260px"
        }
    ]

    const formItemsAdd = [

        {
            label: "用户分类",
            span: 24,
            placeholder: '请选择用户类别',
            model: "category",
            type: 'select',
            options: dic._USER_CATEGORY
        },
        {
            label: "正式编号",
            span: 24,
            placeholder: '请输入学号/员工号',
            model: "numberzs",
        },
        {
            label: "用户名",
            span: 24,
            placeholder: '请输入用户名',
            model: "username",
        },
        {
            label: "密码",
            span: 24,
            placeholder: '请输入密码，8-20个字符，由数字和大小写字母及特殊字符组合',
            model: "password",
            password: true,
        },
        {
            label: "密码确认",
            span: 24,
            placeholder: '请再次输入密码',
            model: "verifyPassword",
            password: true,
        },
        {
            label: "用户姓名",
            span: 24,
            placeholder: '请输入用户姓名',
            model: "name",
        },
        {
            label: "性别",
            span: 24,
            type: 'select',
            model: "sex",
            options: dic._SEXS
        },
        {
            label: "联系电话",
            span: 24,
            placeholder: '请输入联系电话',
            model: "phoneNumber",
        },
        // {
        //     label: "是否数据脱敏",
        //     span: 24,
        //     placeholder: '请选择',
        //     model: "isDesensitize",
        //     type: 'radio',
        //     options: dic._IS,
        // },
        // {
        //     label: "状态",
        //     span: 24,
        //     placeholder: '请选择',
        //     model: "status",
        //     type: 'radio',
        //     options: [
        //         { label: '启用', value: 1 },
        //         { label: '禁用', value: 0 },
        //     ],
        // },
    ]

    const formItemsEdit = [
        {
            label: "用户分类",
            span: 24,
            placeholder: '请选择用户类别',
            model: "category",
            type: 'select',
            options: dic._USER_CATEGORY
        },
        {
            label: "正式编号",
            span: 24,
            placeholder: '请输入学号/员工号',
            model: "numberzs",
        },
        {
            label: "用户名",
            span: 24,
            placeholder: '请输入用户名',
            model: "username",
        },
        {
            label: "用户姓名",
            span: 24,
            placeholder: '请输入用户姓名',
            model: "name",
        },
        {
            label: "性别",
            span: 24,
            type: 'radio',
            model: "sex",
            options: dic._SEXS
        },
        {
            label: "联系电话",
            span: 24,
            placeholder: '请输入联系电话',
            model: "phoneNumber",
        },
        // {
        //     label: "是否数据脱敏",
        //     span: 24,
        //     placeholder: '请选择',
        //     model: "isDesensitize",
        //     type: 'radio',
        //     options: dic._IS,
        // },
        // {
        //     label: "状态",
        //     span: 24,
        //     placeholder: '请选择',
        //     model: "status",
        //     type: 'radio',
        //     options: [
        //         { label: '启用', value: 1 },
        //         { label: '禁用', value: 0 },
        //     ],
        // },
    ]

    const formRulesAdd = {
        orgId: [{
            required: true,
            // message: '请选择所属部门',
            trigger: "change",
            validator: validateOrgId
        }],
        category: [{
            required: true,
            message: '请选择用户类别',
            trigger: "change",
        }],
        numberzs: [{
            required: true,
            message: '请输入编号或工号',
            trigger: "blur",
        }],
        username: [{
            required: true,
            message: '请输入用户名',
            trigger: "blur",
        }],
        password: [{
            required: true,
            message: '请输入密码',
            trigger: "blur",
            validator: validatePass
        }],
        verifyPassword: [{
            required: true,
            // message: '请再次输入密码',
            trigger: "blur",
            validator: validatePassword
        }],
        name: [{
            required: true,
            message: '请输入用户姓名',
            trigger: "blur",
        }],
        sex: [{
            required: true,
            message: '请选择性别',
            trigger: "change",
        }],
        phoneNumber: [{
            required: true,
            trigger: "blur",
            validator: validatePhone,
        }],
        //     isDesensitize: [{
        //         required: true,
        //         message: '请选择是否数据脱敏',
        //         trigger: "change",
        //     }],
        //     status: [{
        //         required: true,
        //         message: '请选择状态',
        //         trigger: "change",
        //     }],
    }
    const formRulesEdit = {
        category: [{
            required: true,
            message: '请选择用户类别',
            trigger: "blur",
        }],
        numberzs: [{
            required: true,
            message: '请输入编号或工号',
            trigger: "blur",
        }],
        username: [{
            required: true,
            message: '请输入用户名',
            trigger: "blur",
        }],
        name: [{
            required: true,
            message: '请输入用户姓名',
            trigger: "blur",
        }],
        phoneNumber: [{
            required: true,
            trigger: "blur",
            validator: validatePhone,
        }],
        // isDesensitize: [{
        //     required: true,
        //     message: '请选择是否数据脱敏',
        //     trigger: "change",
        // }],
        // status: [{
        //     required: true,
        //     message: '请选择状态',
        //     trigger: "change",
        // }],
    }
    const formItemsPwd = [
        {
            label: "用户名",
            span: 24,
            placeholder: '请输入用户名',
            model: "username",
            disabled: true,
        },
        {
            label: "密码",
            span: 24,
            placeholder: '请输入密码，8-20个字符，由数字和大小写字母及特殊字符组合',
            model: "password",
            password: true,
        },
        {
            label: "密码确认",
            span: 24,
            placeholder: '请再次输入密码',
            model: "verifyPassword",
            password: true,
        },
    ]

    const formRulesPwd = {
        password: [{
            required: true,
            // message: '请输入密码',
            trigger: "blur",
            validator: validatePassword
        }],
        verifyPassword: [{
            required: true,
            // message: '请再次输入密码',
            trigger: "blur",
            validator: validateResetPassword
        }],
    }


    const tree = {
        props: {
            parent: "orgId", // 父级唯一标识
            value: "id", // 唯一标识
            label: "name", // 标签显示
            children: "children" // 子级
        }
    }
    return {
        searchItems,
        tableColumns,
        // formItems,
        formItemsAdd,
        formItemsEdit,
        formRulesAdd,
        formRulesEdit,
        formItemsPwd,
        formRulesPwd,
        tree
    }
}
